import { Box, Typography } from '@mui/material'
import React from 'react'
import blogo from '../Assests/billLogo.png';
import { BRAND } from '../constants/brand';

function HomeReport() {
    return (
        <>
            <Box sx={{
                height: '82vh',
                background: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',

            }}>
                <img
                    src={blogo}
                    alt='mainLogo'
                    draggable={false}
                    width='600px'
                    style={{borderRadius : 18}}
                />
                <Typography sx={{
                    fontSize: { md: '50px', xs: '35px' },
                    color: 'black',
                    fontWeight: 'bold',
                    fontFamily: 'Kanit, sans-serif'
                }}>
                    {`${BRAND.name} - Analysis`}
                </Typography>
            </Box>


        </>
    )
}

export default HomeReport
